import { render, staticRenderFns } from "./DutiesList.vue?vue&type=template&id=3a4e197a"
import script from "./DutiesList.vue?vue&type=script&lang=js"
export * from "./DutiesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports